import { useFilteredQueryDataByFreeWord } from "./filter/by-freeword";
import { useGetViewData } from "./use-get-view-data";
import { useSearchSalesMastList } from "./use-search-reservation-list";

type Props = {
	hotelID: string;
};

export const useInitialized = ({ hotelID }: Props) => {
	const {
		searchType,
		onSetSearchType,

		freeTextSearch,
		onSetFreeTextSearch,

		queryData,
		//
		// 収支リストの検索
		onSearchSalesMastList,
	} = useSearchSalesMastList({ hotelID });

	/**
	 * SearchModel をもとに QueryData をフィルタリングする
	 */
	const { queryData: filteredQueryData } = useFilteredQueryDataByFreeWord({ queryData, freeTextSearch });

	/**
	 * ViewData の生成
	 */
	const { viewData } = useGetViewData({ filteredQueryData });

	return {
		searchType,
		onSetSearchType,

		freeTextSearch,
		onSetFreeTextSearch,

		viewData,
		//

		// 収支の検索
		onSearchSalesMastList,
	};
};
